import { LinearProgress } from "@material-ui/core";
import axios from "axios";
import React, { Component } from "react";
import {
  Alert,
  Badge,
  Button,
  ButtonToolbar,
  Form,
  Modal,
  Table,
} from "react-bootstrap";
import Moment from "react-moment";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import AppConfig from "../../../../../config/AppConfig";
import { de } from "date-fns/locale";
class KebijakanLainnya extends Component {
  constructor(props, context) {
    super(props, context);
    this.handleShowAdd = this.handleShowAdd.bind(this);
    this.handleShowEdit = this.handleShowEdit.bind(this);
    this.handleSHowDelete = this.handleSHowDelete.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  state = {
    loading: false,
    showDelete: false,
    showAdd: false,
    showEdit: false,
    showHistorical: false,
    data_historical: [],
    loadingHistorical: false,
    id_jenis_aturan: "",
    id_sp: "",
    status: "",
    keterangan: "",
    tautan: "",
    get_pt_lain: "",
    id_ajuan_pengaturan: "",
    loading2: true,
    loading_edit: false,
  };
  componentDidMount() {
    let id_institusi = localStorage.getItem("id_sp_temp");
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let id_sp = sessiondata.i_idunit;
    if (id_institusi !== "") {
      id_sp = id_institusi;
    }
    if (id_institusi === null) {
      id_sp = sessiondata.i_idunit;
    }
    let session = "";
    if (this.props.idSp !== undefined) {
      id_sp = this.props.idSp;
    }
    if (id_sp) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        id_sp +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    axios
      .get(AppConfig.urlGetPengaturanJenisAturanSiklus + id_sp + "/" + 17 + "/" + tahun_siklus + session)
      .then((res) => {
        console.log(res.data.result);
        this.state.loading2 = false;
        this.setState({
          get_pt_lain: res.data.result.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleClickInterface = (id_jenis_aturan) => {
    let tahun_siklus = localStorage.getItem("tahun_siklus");
    swal({
      title: "Konfirmasi",
      text: "Apakah Anda ingin menyalin seluruh pengaturan SPMI lainnya dari tahun sebelumnya untuk tahun " + tahun_siklus + "?",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }

        this.setState({ loading: true });
        let session_tahun_siklus = localStorage.getItem("tahun_siklus")
        axios.get(AppConfig.urlDefault + "penetapan/savepengaturancpall/" + id_jenis_aturan + "/" + session_tahun_siklus + session)
          .then((res) => {
            this.setState({ loading: false });
            if (res.data.status == "error") {
              swal("Gagal!", res.data.message, {
                icon: "error",
              });
              return
            } else {
              swal("Berhasil!", "Pengaturan telah ditetapkan untuk tahun " + session_tahun_siklus, {
                icon: "success",
              });
            }
            this.componentDidMount();
          })
          .catch((err) => {
            this.setState({ loading: false });
            swal("Gagal!", "Pengaturan gagal ditetapkan untuk tahun " + session_tahun_siklus, {
              icon: "error",
            });
          });
      }
    });
  };
  handleClose() {
    this.setState({
      showDelete: false,
      showAdd: false,
      showEdit: false,
      id_jenis_aturan: "",
      id_sp: "",
      status: "",
      keterangan: "",
      tautan: "",
      deskripsi: "",
      id_ajuan_pengaturan: "",
      showHistorical: false,
      data_historical: [],
      loadingHistorical: false,
    });
  }
  handleSHowDelete() {
    this.setState({
      showDelete: true,
    });
  }
  handleShowAdd() {
    const userdata = JSON.parse(localStorage.getItem("sessiondata"));
    this.setState({
      showAdd: true,
      id_jenis_aturan: 17,
      id_sp: userdata.i_idunit,
      status: 1,
    });
  }
  handleShowEdit = (id) => {
    this.setState({ showEdit: true, loading_edit: true });

    let userdata = JSON.parse(localStorage.getItem("userdata"));
    const sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session =
      // "?token="+userdata.token+
      "?id_pengguna=" +
      userdata.id_pengguna +
      "&id_unit=" +
      sessiondata.i_idunit +
      "&id_role=" +
      sessiondata.i_idrole;

    axios
      .get(AppConfig.urlDetailAjuan + "/" + id + session)
      .then((res) => {
        this.setState(
          {
            loading_edit: false,
            keterangan: res.data.result.data.keterangan !== "null" ? res.data.result.data.keterangan : "",
            deskripsi: res.data.result.data.deskripsi !== "null" ? res.data.result.data.deskripsi : "",
            tautan: res.data.result.data.tautan !== "null" ? res.data.result.data.tautan : "",
            id_ajuan_pengaturan: res.data.result.data.id_ajuan_pengaturan,
          },
          () => {
            console.log(res);
          }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }
  handleShowHistorical = (jenis) => {
    // console.log(jenis);
    this.setState({ showHistorical: true });
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }

    let id_institusi = localStorage.getItem("id_sp_temp");
    if (id_institusi === undefined) {
      id_institusi = sessiondata.i_idunit;
    }

    let tahun_siklus = localStorage.getItem("tahun_siklus");
    axios
      .get(
        AppConfig.urlGetHistoricalPengaturanSiklus +
        id_institusi +
        "/" +
        jenis +
        "/" +
        tahun_siklus +
        session
      )
      .then((res) => {
        console.log(res);
        this.setState({
          data_historical: res.data.result.data,
          loadingHistorical: true,
        });
      })
      .catch((err) => {
        console.log(err);
        // this.setState({
        //   display_edit: false,
        //   showDialogFormSave: false,
        // });
      });
  };
  showDialogDelete(id) {
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    if (userdata) {
      session =
        // "?token="+userdata.token+
        "?id_pengguna=" +
        userdata.id_pengguna +
        "&id_unit=" +
        sessiondata.i_idunit +
        "&id_role=" +
        sessiondata.i_idrole;
    }
    swal({
      title: "Apakah anda yakin?",
      text: "Catatan akan terhapus, dan tidak tercatat pada historical",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        this.setState({ loading: true });
        axios
          .get(AppConfig.urlDeletePengaturan + id + session)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Pengaturan standar lain berhasil dihapus!",
              icon: "success",
              button: "OK!",
            });
            this.componentDidMount();
            this.setState({
              loading: false,
              showAda: false,
              showEdit: false,
              tautan: [],
              tanggal_penetapan: [],
              status: [],
              id_jenis_evaluasi: [],
            });
            console.log(res);
          })
          .catch((err) => {
            swal({
              title: "Gagal!",
              text: "Pengaturan gagal dihapus!",
              icon: "error",
              button: "OK!",
            });
            // alert("GAGAL")
            this.setState({
              loading: false,
            });
          });
      }
    });
  }
  showConfirmDialog = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        this.setState({ loading: true });
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        e.preventDefault();
        var formData = new FormData();
        formData.append("data[id_jenis_aturan]", this.state.id_jenis_aturan);
        formData.append("data[tautan]", this.state.tautan);
        formData.append("data[deskripsi]", this.state.deskripsi);
        formData.append("data[keterangan]", this.state.keterangan);
        let session_tahun_siklus = localStorage.getItem("tahun_siklus")
        formData.append("data[tahun_siklus]", session_tahun_siklus);
        formData.append("data[status]", this.state.status);
        formData.append("data[id_sp]", this.state.id_sp);
        axios.defaults.headers.post["Content-Type"] =
          "application/x-www-form-urlencoded";
        axios
          .post(AppConfig.urlAPiPostDataPT + session, formData)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "Pengaturan standar lain berhasil!",
              icon: "success",
              button: "OK!",
            });
            // alert("BERHASIL")
            // console.log(res)
            this.componentDidMount();
            this.setState({
              showAda: false,
              showTidakAda: false,
              id_jenis_aturan: "",
              tautan: "",
              keterangan: "",
              deskripsi: "",
              status: "",
              id_sp: "",
              loading: false,
              showDelete: false,
              showAdd: false,
              showEdit: false,
            });
          })
          .catch((err) => {
            // alert("GAGAL")
            swal({
              title: "Gagal!",
              text: "proses gagal!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              showAda: false,
              showTidakAda: false,
              id_jenis_aturan: "",
              tautan: "",
              keterangan: "",
              deskripsi: "",
              status: "",
              id_sp: "",
              loading: false,
              showDelete: false,
              showAdd: false,
              showEdit: false,
            });
          });
      }
    });
  };

  showConfirmEditDialog = (e) => {
    swal({
      title: "Anda yakin?",
      text: "Pastikan verifikator dapat melihat dokumen yang Anda upload!",
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then((willSave) => {
      if (willSave) {
        this.setState({ loading: true });
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let session = "";
        if (userdata) {
          session =
            // "?token="+userdata.token+
            "?id_pengguna=" +
            userdata.id_pengguna +
            "&id_unit=" +
            sessiondata.i_idunit +
            "&id_role=" +
            sessiondata.i_idrole;
        }
        e.preventDefault();
        var formData = new FormData();
        formData.append("data[tautan]", this.state.tautan);
        formData.append("data[deskripsi]", this.state.deskripsi);
        formData.append("data[keterangan]", this.state.keterangan);
        formData.append("data[id_jenis_aturan]", "17");

        axios.defaults.headers.post["Content-Type"] =
          "application/x-www-form-urlencoded";
        axios
          .put(AppConfig.urlAPiPutDataPT + "/" + this.state.id_ajuan_pengaturan + session, formData)
          .then((res) => {
            swal({
              title: "Berhasil!",
              text: "pengaturan berhasil!",
              icon: "success",
              button: "OK!",
            });
            // alert("BERHASIL")
            // console.log(res)
            this.componentDidMount();
            this.setState({
              showAda: false,
              showTidakAda: false,
              id_ajuan_pengaturan: "",
              id_jenis_aturan: "",
              tautan: "",
              keterangan: "",
              deskripsi: "",
              status: "",
              id_sp: "",
              loading: false,
              showDelete: false,
              showAdd: false,
              showEdit: false,
            });
          })
          .catch((err) => {
            // alert("GAGAL")
            swal({
              title: "Gagal!",
              text: "proses gagal!",
              icon: "error",
              button: "OK!",
            });
            this.setState({
              showAda: false,
              showTidakAda: false,
              id_ajuan_pengaturan: "",
              id_jenis_aturan: "",
              tautan: "",
              keterangan: "",
              status: "",
              id_sp: "",
              loading: false,
              showDelete: false,
              showAdd: false,
              showEdit: false,
            });
          });
      }
    });
  };

  onInputChange = (e, type) => {
    this.setState({
      [type]: e.target.value,
    });
  };
  render() {
    let {
      deskripsi,
      tautan,
      keterangan,
      loading,
      get_pt_lain,
      data_historical,
    } = this.state;
    let userdata = JSON.parse(localStorage.getItem("sessiondata"));
    let i = 0;
    let result_p_lain = [];
    if (get_pt_lain !== undefined) {
      for (var key in get_pt_lain) {
        result_p_lain[i] = {
          name: key,
          result: get_pt_lain[key],
          // "result2": Object.keys(p_publikasi[key]).map((keys) =>
          // Object.assign({"year":Number(keys),"count":p_publikasi[key][keys]}))
        };
        i++;
      }
    }
    console.log(userdata.i_idrole);
    // console.log("DATA =", result_p_lain);

    let display_historical = [];
    if (this.state.loadingHistorical === true) {
      data_historical.map((list, i) => {
        display_historical.push(
          <>
            <tr>
              <td>{list.keterangan}</td>
              <td style={{ textAlign: "center" }}>
                {list.tautan === "null" ? (
                  list.keterangan
                ) : (
                  <a target="_blank" className="menu-link" href={list.tautan}>
                    <Button
                      className="btn btn-icon btn-success btn-sm"
                      style={{ minWidth: "50px", borderRadius: "12px" }}
                    >
                      <i
                        className="flaticon-attachment"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </a>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.statusajuan === 3 ? (
                  <Badge
                    pill
                    variant="success"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#37bf30" }}>✔</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Terverifikasi
                  </Badge>
                ) : list.statusajuan === 1 ? (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    <Badge variant="light">
                      {" "}
                      <span style={{ color: "#858585" }}>•</span>
                    </Badge>
                    &nbsp;&nbsp;&nbsp; Belum Terverifikasi
                  </Badge>
                ) : (
                  <Badge
                    pill
                    variant="secondary"
                    style={{
                      backgroundColor: "#BEF2FF",
                      color: "#334443",
                      fontSize: "12px",
                    }}
                  >
                    -
                  </Badge>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {list.tanggal_penetapan === "null" ? (
                  "-"
                ) : (
                  <Moment
                    format="DD/MM/YYYY"
                    date={
                      list.tanggal_penetapan === "null"
                        ? "-"
                        : list.tanggal_penetapan
                    }
                  />
                )}
              </td>
              <td style={{ textAlign: "center" }}>{(list.catatan !== "null" ? list.catatan : "-")}</td>
            </tr>
          </>
        );
      });
    } else {
      display_historical = (
        <>
          <tr>
            <td colSpan="5">
              <LinearProgress color="secondary" variant="query" />
            </td>
          </tr>
        </>
      );
    }
    return (
      <>
        {userdata.i_idrole === 3 ? (
          <div className="row" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <div style={{ float: "right" }}>
                <ButtonToolbar>
                  <span className="svg-icon svg-icon-2x svg-icon-white">
                    <Button variant="primary" onClick={this.handleShowAdd}>
                      <i
                        className="flaticon-add-circular-button"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                      &nbsp; Tambahkan Standar Lain
                    </Button>

                    <Button
                      onClick={() => this.handleClickInterface("17")}
                      className="btn btn-icon btn-warning"
                      style={{ minWidth: "50px", margin: "0px 2px" }}
                    >
                      <i
                        class="flaticon-interface-4"
                        style={{ color: "#ffffff", fontSize: "14px" }}
                      ></i>
                    </Button>
                  </span>
                </ButtonToolbar>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <Table responsive style={{ width: "100%", overflow: "overlay" }}>
          <thead className="text-white" style={{ backgroundColor: "#3047ad" }}>
            <tr>
              <th
                style={{
                  width: "5%",
                  textAlign: "center",
                  textTransform: "uppercase",
                  verticalAlign: "middle",
                }}
              >
                No
              </th>
              <th style={{ minWidth: "45%", textTransform: "uppercase" }}>
                Nama Pengaturan
              </th>
              <th
                className="text-center"
                style={{ minWidth: "25%", textTransform: "uppercase" }}
              >
                Tautan
              </th>
              <th
                className="text-center"
                style={{ minWidth: "25%", textTransform: "uppercase" }}
              >
                Status Verifikasi
              </th>
              <th
                className="text-center"
                style={{ minWidth: "25%", textTransform: "uppercase" }}
              >
                Status Dokumen
              </th>
              <th
                className="text-center"
                style={{ minWidth: "25%", textTransform: "uppercase" }}
              >
                Aksi
              </th>
            </tr>
          </thead>
          <tbody>
            {this.state.loading2 === true ? (
              <>
                <tr>
                  <td colSpan="6">
                    <LinearProgress color="secondary" variant="query" />
                  </td>
                </tr>
              </>
            ) : result_p_lain.length > 0 ? (
              result_p_lain.map((list, i) => (
                <>
                  <tr>
                    <td
                      style={{ textAlign: "center", verticalAlign: "middle" }}
                    >
                      {i + 1}
                    </td>
                    <td style={{ verticalAlign: "middle" }}>
                      {list.result.keterangan}
                    </td>
                    <td className="text-center">
                      <Button
                        href={list.result.tautan}
                        target="_blank"
                        className="btn btn-icon btn-light btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                          background: "#A9C6DE",
                        }}
                      >
                        <i
                          className="flaticon-attachment"
                          style={{ color: "#3F4254", fontSize: "14px" }}
                        ></i>
                      </Button>
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        verticalAlign: "middle",
                      }}
                    >
                      {list.result.statusajuan === 3 ? (
                        <Badge
                          pill
                          variant="success"
                          style={{
                            backgroundColor: "#BEF2FF",
                            color: "#334443",
                            fontSize: "12px",
                          }}
                        >
                          <Badge variant="light">
                            {" "}
                            <span style={{ color: "#37bf30" }}>✔</span>
                          </Badge>
                          &nbsp;&nbsp;&nbsp; Terverifikasi
                        </Badge>
                      ) : (
                        <Badge
                          pill
                          variant="secondary"
                          style={{
                            backgroundColor: "#BEF2FF",
                            color: "#334443",
                            fontSize: "12px",
                          }}
                        >
                          Belum Terverifikasi
                        </Badge>
                      )}
                    </td>
                    <td
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        verticalAlign: "middle",
                      }}
                    >
                      {list.result.dokumen_valid === "1" ? (
                        <Badge
                          pill
                          variant="success"
                          style={{
                            backgroundColor: "#BEF2FF",
                            color: "#334443",
                            fontSize: "12px",
                          }}
                        >
                          <Badge variant="light">
                            {" "}
                            <span style={{ color: "#37bf30" }}>✔</span>
                          </Badge>
                          &nbsp;&nbsp;&nbsp; Sudah valid
                        </Badge>
                      ) : list.result.dokumen_valid === "0" ? (
                        <Badge
                          pill
                          variant="warning"
                          style={{
                            color: "#334443",
                            fontSize: "12px",
                          }}
                        >
                          Belum Valid
                        </Badge>
                      ) : (
                        <Badge
                          pill
                          variant="secondary"
                          style={{
                            backgroundColor: "#CCCCCC",
                            color: "#FFFFFF",
                          }}
                        >
                          Dokumen belum diverifikasi
                        </Badge>
                      )}
                    </td>
                    <td className="text-center pr-0">
                      {userdata.i_idrole === 3 ? (
                        <>
                          <Link
                            to={
                              "/ajuan-pengaturan/detail/" +
                              list.result.id_ajuan_pengaturan
                            }
                          >
                            <Button
                              className="btn btn-icon btn-primary btn-sm"
                              style={{ minWidth: "50px", borderRadius: "12px" }}
                            >
                              <i
                                className="flaticon-eye"
                                style={{ color: "#ffffff", fontSize: "14px" }}
                              ></i>
                            </Button>
                          </Link>
                          {
                            list.result.statusajuan === 1 || (list.result.dokumen_valid === "0" || list.result.dokumen_valid === "null") ? (
                              <Button
                                onClick={() =>
                                  this.handleShowEdit(list.result.id_ajuan_pengaturan)
                                }
                                className="btn btn-icon btn-warning btn-sm"
                                style={{
                                  minWidth: "50px",
                                  marginLeft: "5px",
                                  margintight: "5px",
                                  borderRadius: "12px",
                                }}
                              >
                                <i
                                  class="flaticon-edit"
                                  style={{ fontSize: "14px" }}
                                ></i>
                              </Button>
                            ) : (
                              ""
                            )
                          }
                              <Button
                                onClick={() =>
                                  this.showDialogDelete(
                                    list.result.id_ajuan_pengaturan
                                  )
                                }
                                className="btn btn-icon btn-danger btn-sm"
                                style={{
                                  minWidth: "50px",
                                  borderRadius: "12px",
                                  marginLeft: "5px",
                                }}
                              >
                                <i
                                  className="flaticon-delete"
                                  style={{ color: "#FFFFFF", fontSize: "14px" }}
                                ></i>
                              </Button>
                        </>
                      ) : (
                        ""
                      )}
                      {userdata.i_idrole === 10 ||
                        userdata.i_idrole === 2013 ||
                        userdata.i_idrole === 2014 ? (
                        <Link
                          to={
                            "/ajuan-pengaturan/detail/" +
                            list.result.id_ajuan_pengaturan
                          }
                        >
                          <Button
                            className="btn btn-icon btn-primary btn-sm"
                            style={{ minWidth: "50px", borderRadius: "12px" }}
                          >
                            <i
                              className="flaticon-eye"
                              style={{ color: "#ffffff", fontSize: "14px" }}
                            ></i>
                          </Button>
                        </Link>
                      ) : (
                        ""
                      )}
                      {/* <Button
                        onClick={() =>
                          this.handhandleShowHistorical(
                            list.result.id_jenis_aturan
                          )
                        }
                        className="btn btn-icon btn-success btn-sm"
                        style={{
                          minWidth: "50px",
                          borderRadius: "12px",
                          marginLeft: "5px",
                        }}
                      >
                        <i
                          className="flaticon2-time"
                          style={{ color: "#ffffff", fontSize: "14px" }}
                        ></i>
                      </Button> */}
                    </td>
                  </tr>
                </>
              ))
            ) : (
              <>
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    <em>Data does not exist</em>
                  </td>
                </tr>
              </>
            )}
          </tbody>
        </Table>

        <Modal size="lg" show={this.state.showAdd} onHide={this.handleClose}>
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Standar Lain Yang Ditetapkan Institusi </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Label>Nama Bidang Pengaturan Standar</Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="Nama Standar"
                value={keterangan}
                onChange={(e) => this.onInputChange(e, "keterangan")}
              />
              <br />
              <Form.Label htmlFor="input-with-icon-adornment">
                Deskripsi <small>*jika ada</small>{" "}
              </Form.Label>
              <Form.Control
                size="lg"
                type="text"
                as="textarea"
                placeholder="Deskripsi"
                value={deskripsi}
                onChange={(e) => this.onInputChange(e, "deskripsi")}
              />
              <br />
              <Form.Label>Tautan terkait</Form.Label>
              <Form.Control
                size="lg"
                type="text"
                placeholder="https://..."
                value={tautan}
                onChange={(e) => this.onInputChange(e, "tautan")}
              />
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  marginTop: "15px",
                  marginRight: "20px",
                  marginLeft: "20px",
                }}
              >
                <Alert variant="warning">
                  <b>
                    *Catatan: Pastikan link/tautan yang diberikan dapat
                    diakses/dibaca oleh publik!
                  </b>
                  <br />
                  (General Access : Anyone With The Link)
                </Alert>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                disabled={loading}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
                onClick={this.showConfirmDialog}
              >
                Simpan
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal size="lg" show={this.state.showEdit} onHide={this.handleClose}>
          <Form>
            <Modal.Header closeButton>
              <Modal.Title>Edit Standar Lain Yang Ditetapkan Institusi</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {this.state.loading_edit === true ? (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <LinearProgress color="secondary" variant="query" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <Form.Label>Nama Bidang Pengaturan Standar</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder="Nama Standar"
                    value={keterangan}
                    onChange={(e) => this.onInputChange(e, "keterangan")}
                  />
                  <br />
                  <Form.Label htmlFor="input-with-icon-adornment">
                    Deskripsi <small>*jika ada</small>{" "}
                  </Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    as="textarea"
                    placeholder="Deskripsi"
                    value={deskripsi}
                    onChange={(e) => this.onInputChange(e, "deskripsi")}
                  />
                  <br />
                  <Form.Label>Tautan terkait</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    placeholder="https://..."
                    value={tautan}
                    onChange={(e) => this.onInputChange(e, "tautan")}
                  />
                  <div
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      marginTop: "15px",
                      marginRight: "20px",
                      marginLeft: "20px",
                    }}
                  >
                    <Alert variant="warning">
                      <b>
                        *Catatan: Pastikan link/tautan yang diberikan dapat
                        diakses/dibaca oleh publik!
                      </b>
                      <br />
                      (General Access : Anyone With The Link)
                    </Alert>
                  </div>
                </>
              )}

            </Modal.Body>
            <Modal.Footer>
              <Button
                disabled={loading}
                style={{
                  marginRight: "1vw",
                  backgroundColor: "#2061e3",
                  color: "white",
                }}
                variant="primary"
                onClick={this.showConfirmEditDialog}
              >
                Simpan
                {loading && <i className="ml-3 spinner spinner-white"></i>}
                &nbsp;&nbsp;
              </Button>
              <Button variant="secondary" onClick={this.handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        <Modal
          size="lg"
          show={this.state.showHistorical}
          onHide={this.handleClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>Riwayat Pengaturan Penetapan</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table responsive style={{ overflow: "auto" }}>
              <thead
                className="text-white"
                style={{ backgroundColor: "#3047ad" }}
              >
                <th style={{ textAlign: "center" }}>Nama Pengaturan</th>
                <th style={{ textAlign: "center" }}>Tautan</th>
                <th style={{ textAlign: "center" }}>Status Verfikasi</th>
                <th style={{ textAlign: "center" }}>Tanggal Penetapan</th>
                <th style={{ textAlign: "center" }}>Catatan</th>
              </thead>
              <tbody>{display_historical}</tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
export default KebijakanLainnya;
